import Vue from 'vue'
import Vuex from 'vuex'
import { editor } from './editor'
import { contact } from './contact'
import { firebaseMutations } from 'vuexfire'
import { firebase } from './api/firebase'
import { cropData } from './crop-data'
import { inventoryCounts } from './counts'
import { itemFilters } from './itemFilters'
import { layout } from './layout'
import inventory from './inventory'
import { inventoryExport } from './inventoryExport'
import { prices } from './prices'
import tour from './tours'
import user from './user'

let marketplace = Object.assign({}, inventory)
let pending = Object.assign({}, inventory)
let queue = Object.assign({}, inventory)
Vue.use(Vuex)
Vue.use(firebase)
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    cropData, contact, editor, inventoryCounts, inventoryExport, inventory, itemFilters, layout, marketplace, pending, prices, queue, tour, user
  },
  mutations: firebaseMutations
})



// WEBPACK FOOTER //
// ./src/store/index.js